<template>
  <page-wrapper :title="title" ref="pageEl">
    <div class="container-receipt">
      <div class="d-flex justify-content-between">
        <div>
          <p class="mb-1 mt-2" v-if="total">{{ totalCount }}</p>
          <div class="d-flex flex-row">
            <el-checkbox-group v-model="checkedFilters" :min="0" :max="1">
              <el-checkbox
                v-bind:value="isFilteredByPack"
                @change="handlePackageNotSendEztax"
                label="pack"
                ><p class="mb-1 mt-2">
                  แพ็กแรกพบที่ส่ง eztax ไม่ผ่าน
                </p></el-checkbox
              >
              <el-checkbox
                v-bind:value="isFilteredByResend"
                @change="handleGetResendReceipt"
                label="resend"
                ><p class="mb-1 mt-2">
                  ใบเสร็จที่ต้องการ Resend
                </p></el-checkbox
              >
            </el-checkbox-group>
            <div class="space md-2 ml-5">
              <el-select
                v-model="query.filterSellerTradeParty"
                placeholder="เลือก ผู้จัดหาบริการ"
                @change="handleChangeSellerTradeParty" clearable
              >
                <el-option
                  v-for="t in sellerTradePartyOptions"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div>
          <sc-button
          class="primary"
          @click="handleCancelReceipt"
          v-bind:disabled="isViewOnlyByRole"
            >ยกเลิกใบเสร็จ</sc-button
          >
        </div>
      </div>
      <div class="receipt-row header">
        <div class="cell date">วันที่</div>
        <div class="cell client">ผู้รับบริการ</div>
        <div class="cell type">ผู้จัดหาบริการ</div>
        <div class="cell type">ชนิด</div>
        <div class="cell total">ยอดรวม</div>
        <div class="cell reason">ไม่ส่งเพราะ</div>
      </div>
      <div class="text-center mt-4" v-if="!total">ไม่มีข้อมูล</div>
      <div class="mb-4">
        <router-link
          class="receipt-row"
          v-for="r in list"
          :key="r.id"
          :to="r.route"
        >
          <div class="cell date">{{ r.createdAt }}</div>
          <div class="cell client">{{ r.clientName }}</div>
          <div class="cell type">{{ r.sellerTradeParty }}</div>
          <div class="cell type">{{ r.type }}</div>
          <div class="cell total">{{ r.total }}</div>
          <div class="cell reason">{{ r.noReceiptReason }}</div>
        </router-link>
      </div>
      <div class="text-right">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :size="10"
          :current-page="query.page"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-drawer
        title="ยกเลิกใบเสร็จ"
        :before-close="handleCloseCancelReceiptDialog"
        :visible.sync="cancelReceiptDialog.isShow"
        direction="rtl"
        custom-class="demo-drawer"
        ref="drawer"
        :with-header="false"
      >
        <div class="ml-2 my-4 d-flex flex-column">
          <span class="col-12 drawer-title">ยกเลิกใบเสร็จ</span>
          <span class="col-12 drawer-sub-title">สามารถดูเลขที่ใบกำกับภาษี และผู้จัดหาบริการได้ที่หน้า รายละเอียดสมาชิก</span>
        </div>
        <div class="demo-drawer__content row">
          <div class="mx-4 mb-4">
            <label class="label col-12 mb-1">เลขที่ใบเสร็จ (ตามที่ส่ง EZTax)</label>
            <el-input
              v-model="cancelReceiptDialog.documentNumber"
              class="mb-3 col-12 input sellerTradeParty"
            ></el-input>
            <label class="label col-12 mb-1">ผู้จัดหาบริการ</label>
            <el-select
              class="mb-4 col-12 input sellerTradeParty"
              v-model="cancelReceiptDialog.sellerTradePartyId"
              placeholder="เลือกผู้จัดหาบริการ"
            >
              <el-option
                v-for="option in sellerTradePartyOptions"
                :key="option.value"
                :value="option.value"
                :label="option.label"
              >{{ option.label }}</el-option>
            </el-select>
            <div class="col-12">
              <el-button @click="handleCloseCancelReceiptDialog">ยกเลิก</el-button>
              <el-button
                type="primary"
                @click="handleConfirmCancelReceipt"
                :loading="cancelReceiptDialog.isLoading"
              >{{ cancelReceiptDialog.isLoading ? 'กำลังยกเลิกใบเสร็จ..' : 'ยกเลิกใบเสร็จ' }}</el-button>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </page-wrapper>
</template>

<script>
import { DateTime } from "luxon";
import {
  Pagination,
  Drawer,
  Select,
  Option,
  Button,
  Input,
  Checkbox,
  CheckboxGroup
} from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { toLocaleTH } from "@/lib/dateTime";
import { formatToMoney, formatDecimal } from "@/lib/formatter";
import { receiptTypeTH } from "@/lib/mapper";

export default {
  components: {
    PageWrapper,
    ScButton,
    "el-pagination": Pagination,
    "el-drawer": Drawer,
    "el-select": Select,
    "el-option": Option,
    "el-button": Button,
    "el-input": Input,
    "el-checkbox": Checkbox,
    "el-checkbox-group": CheckboxGroup
  },
  data() {
    const title = "รายการใบเสร็จ";
    const list = [];
    const total = 1;
    const query = {};
    const cancelReceiptDialog = {
      isShow: false,
      isLoading: false,
      documentNumber: "",
      sellerTradePartyId: ""
    }
    const sellerTradeParties = [];
    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;


    return {
      title,
      list,
      total,
      query,
      cancelReceiptDialog,
      sellerTradeParties,
      checkedFilters: [],
      permission
    };
  },
  computed: {
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page;
      const end = (isLastPage ? total : currentPage * limit);
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    sellerTradePartyOptions() {
      const sellerTradePartyOptions = this.sellerTradeParties.map(seller => ({
        value: seller.id,
        label: seller.name
      }));

      return sellerTradePartyOptions;
    },
    isFilteredByPack() {
      return this.checkedFilters.includes("pack");
    },
    isFilteredByResend() {
      return this.checkedFilters.includes("resend");
    },
    isViewOnlyByRole() {
      const roles = ["AC"]
      return roles.includes(this.permission.role)
    }
  },
  watch: {
    async "$route.query"(query) {
      this.setupQuery();
      await this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupSellerTradeParties();
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      // TODO: change this condition when has new solution for check boolean in route query
      const isFilteredByPack =
        typeof this.$route.query.isFilteredByPack === "boolean"
          ? this.$route.query.isFilteredByPack
          : this.$route.query.isFilteredByPack === "true";
      const isFilteredByResend =
        typeof this.$route.query.isFilteredByResend === "boolean"
          ? this.$route.query.isFilteredByResend
          : this.$route.query.isFilteredByResend === "true";

      this.query = {
        page: parseInt(this.$route.query.page) || 1,
        isFilteredByPack: isFilteredByPack,
        isFilteredByResend: isFilteredByResend,
        filterSellerTradeParty: this.$route.query.filterSellerTradeParty
      };

      if (isFilteredByPack && !this.checkedFilters.includes("pack"))
        this.checkedFilters.push("pack");
      if (isFilteredByResend && !this.checkedFilters.includes("resend"))
        this.checkedFilters.push("resend");
    },
    setupData() {
      this.setupList();
    },
    async setupSellerTradeParties() {
      const sellerTradeParties = await this.fetchSellerTradeParties();

      this.sellerTradeParties = sellerTradeParties;
    },
    async setupList() {
      const { count, receipts } = this.query.isFilteredByResend
        ? await this.fetchResendList()
        : await this.fetchList();

      this.total = count;
      this.list = receipts.map(receipt => {
        const amount = receipt.amount || 0;
        const priceBeforeDiscount = receipt.price_before_discount !== null
          && receipt.price_before_discount >= 0
          ? receipt.price_before_discount
          : formatDecimal(amount) * receipt.quantity;

        const sellerTradeParty =  this.sellerTradeParties.find(i => i.id === receipt.seller_trade_party_id).name

        return {
          id: receipt.id,
          docNo: receipt.document_number || "-",
          createdAt: DateTime.fromISO(receipt.created_at)
            .setZone("utc+7")
            .setLocale("th")
            .toFormat("dd MMM yyyy"),
          clientName: receipt.owner_name,
          total: formatToMoney(priceBeforeDiscount),
          type: receiptTypeTH[receipt.type],
          route: { name: "ReceiptDetailPage", params: { id: receipt.id } },
          sellerTradeParty,
          noReceiptReason: receipt.is_manual_payment ? 'ซื้อนอกระบบ' : '-'
        };
      });
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.receipts.getUnsent(
        this.query
      );

      return response.data.result;
    },
    async fetchResendList() {
      const response = await baanRueJaiClient.admin.subscriptions.receipts.getResend(
        {
          status: "WAIT_FOR_RESEND",
          page: this.query.page,
          page_size: 10,
          seller_trade_party: this.query.filterSellerTradeParty
        }
      );

      return response.data.result;
    },
    async fetchSellerTradeParties() {
      const response = await baanRueJaiClient.admin.subscriptions.receipts.getAllSellerTradeParties();

      return response.data.result;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page,
          isFilteredByPack: this.isFilteredByPack,
          isFilteredByResend: this.isFilteredByResend,
          filterSellerTradeParty: this.query.filterSellerTradeParty
        }
      };

      this.$router.replace(route);
    },
    handleCancelReceipt() {
      this.cancelReceiptDialog.isShow = true;
    },
    handleCloseCancelReceiptDialog() {
      this.cancelReceiptDialog.documentNumber = "";
      this.cancelReceiptDialog.sellerTradePartyId = "";

      this.cancelReceiptDialog.isShow = false;
    },
    async handleConfirmCancelReceipt() {
      this.cancelReceiptDialog.isLoading = true;

      const {
        documentNumber,
        sellerTradePartyId
      } = this.cancelReceiptDialog;

      try {
        await baanRueJaiClient.admin.subscriptions.receipts.postCancelReceipt({
          document_number: documentNumber,
          seller_trade_party_id: sellerTradePartyId
        });

        alert("ยกเลิกใบเสร็จสำเร็จ");

        this.cancelReceiptDialog.isLoading = false;
        this.cancelReceiptDialog.isShow = false;
        this.cancelReceiptDialog.documentNumber = "";
        this.cancelReceiptDialog.sellerTradePartyId = "";

        this.setup();
      } catch(error) {
        alert("ไม่สามารถยกเลิกใบเสร็จได้ กรุณาลองใหม่อีกครั้ง");

        console.error(error);

        this.cancelReceiptDialog.isLoading = false;
      }
    },
    async handlePackageNotSendEztax() {
      this.query = {
        ...this.$route.query,
        page: this.query.page,
        isFilteredByPack: this.isFilteredByPack
      }
      await this.setupData();
    },
    async handleGetResendReceipt() {
      this.query = {
        ...this.$route.query,
        page: 1,
        isFilteredByResend: this.isFilteredByResend
      };

      this.handleCurrentChange(1);
    },
    handleChangeSellerTradeParty() {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          filterSellerTradeParty: this.query.filterSellerTradeParty
        }
      };

      this.$router.replace(route);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  padding-top: $space;
  padding-bottom: $space;
}

.input {
  &.sellerTradeParty {
    width: 350px
  }
}

.drawer {
  &-title {
    font-size: 20px;
  }

  &-sub-title {
    font-size: 13px;
    color: rgb(133, 131, 131);
  }
}

.receipt-row {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 100px 220px 330px 200px 90px 120px;
  align-items: center;
  width: max-content;
  border-bottom: $border;
  padding: 15px 10px;
  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    padding-bottom: 5px;

    color: #999;
    font-size: 14px;
  }

  > .total,
  > .action {
    text-align: right;
  }

  > .reason {
    text-align: center;
  }
}

.container-receipt {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/receipts/pages/ReceiptDashboardPage.vue